/**
 * Content editor IIFE entry point.
 *
 * Bootstraps the editor when the DOM is ready and exports a debug
 * API on `window.__MUSK_EDITOR__`. When bundled by esbuild this
 * module produces the same self-executing behavior as the original
 * `original-musk-html-editor.js`.
 */

import initEditor, { getDebugApi } from './init'
import { log } from './utils'

declare global {
  interface Window {
    __MUSK_EDITOR__?: any,
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEditor)
} else {
  initEditor()
}

window.__MUSK_EDITOR__ = getDebugApi()

log('编辑器API已导出到 window.__MUSK_EDITOR__')
